import React from 'react';
import { useTranslation } from 'react-i18next';
import LocationTree from './LocationTree';
import DateRangeControl from './DateRangeControl';

/**
 * AnalyticsFilters — Sprint 3.7. Filter rail with location tree, metric
 * checkboxes, and date range controls. State is fully controlled by parent.
 */

const METRIC_DEFS = [
    { key: 'sales',                  label: 'Sales' },
    { key: 'transCount',             label: 'Transactions' },
    { key: 'atv',                    label: 'ATV' },
    { key: 'fb',                     label: 'F&B Sales' },
    { key: 'revenueShareAmount',     label: 'Revenue Share' },
    { key: 'revenueSharePercentage', label: 'Revenue Share %' },
    { key: 'baseRent',               label: 'Base Rent' },
];

export default function AnalyticsFilters({
    tree,
    treeLoading,
    selection,
    onSelectionChange,
    metricsFlags,
    onMetricsChange,
    dateRange,
    onDateRangeChange,
}) {
    const { t } = useTranslation();
    const toggleMetric = (key) => {
        onMetricsChange({ ...metricsFlags, [key]: metricsFlags[key] ? 0 : 1 });
    };

    return (
        <aside className="v3-card v3-anlx-rail" aria-label={t('Analytics filters')}>
            <section className="v3-anlx-rail-section">
                <h3 className="v3-anlx-rail-title">{t('Date Range')}</h3>
                <DateRangeControl range={dateRange} onChange={onDateRangeChange} />
            </section>

            <section className="v3-anlx-rail-section">
                <h3 className="v3-anlx-rail-title">{t('Locations')}</h3>
                {treeLoading ? (
                    <>
                        <div className="v3-anlx-skel line long" />
                        <div className="v3-anlx-skel line long" />
                        <div className="v3-anlx-skel line short" />
                    </>
                ) : (
                    <LocationTree
                        tree={tree}
                        selection={selection}
                        onChange={onSelectionChange}
                    />
                )}
            </section>

            <section className="v3-anlx-rail-section">
                <h3 className="v3-anlx-rail-title">{t('Metrics')}</h3>
                <div className="v3-anlx-metrics">
                    {METRIC_DEFS.map(m => {
                        const on = !!metricsFlags[m.key];
                        return (
                            <label
                                key={m.key}
                                className={`v3-anlx-metric-row${on ? ' is-on' : ''}`}
                            >
                                <input
                                    type="checkbox"
                                    checked={on}
                                    onChange={() => toggleMetric(m.key)}
                                />
                                {t(m.label)}
                            </label>
                        );
                    })}
                </div>
            </section>
        </aside>
    );
}
